import * as React from 'react';
import * as moment from 'moment';
import { Icon, DriverAvatar, IconAvatar, DateTime, Tooltip } from '../';
import BaseList from '../BaseList/BaseList';

interface Props {
  items: Array<any>;
  showEmail?: boolean;
  showJoinDate?: boolean;
  handleClick?: any;
  hideSearch?: boolean;
  renderBody?: any;
  noAnimation?: boolean;
  isSelected?: (id: number) => boolean;
  small?: boolean;
  showLicence?: boolean;
  handleRemove?: any;
  showReputation?: boolean;
}

class DriverList extends BaseList<Props> {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.drivers.search,
      search: BaseList.search.drivers,
      path: props.handleRemove ? false : 'drivers',
      name: 'drivers',
    });
  }

  isSelected(driver) {
    return this.props.isSelected && this.props.isSelected(driver.id);
  }

  renderLeft(driver) {
    if (this.isSelected(driver)) {
      return <IconAvatar icon="check" colour="#345dc3" iconColour="#fff" />;
    }
    return (
      <DriverAvatar size={this.props.small ? '48' : '64'} driver={driver} />
    );
  }

  renderFoot(driver) {
    return null;
  }

  renderHead(driver, index) {
    return (
      <>
        {this.props.showJoinDate && (
          <small className="is-pulled-right has-text-grey">
            Created <DateTime date={driver.created_at} />
          </small>
        )}
        {this.props.handleRemove && (
          <div className="is-pulled-right">
            <Tooltip text="Remove">
              <a
                onClick={() => this.props.handleRemove(driver, index)}
                className="delete"
              />
            </Tooltip>
          </div>
        )}
        {this.props.showReputation && driver.reputation === 2 && (
          <div className="tags is-pulled-right" style={{ marginRight: '5px' }}>
            <Tooltip text="Driver with bad reputation">
              <span className="tag is-danger">BAD</span>
            </Tooltip>
          </div>
        )}
        <strong style={this.isSelected(driver) ? { color: '#345dc3' } : {}}>
          {driver.name}
        </strong>
      </>
    );
  }

  renderBody(driver) {
    return (
      <>
        {!!driver.company_name && (
          <>
            <br />
            {driver.company_name}
          </>
        )}
        {!!driver.phone_number && (
          <>
            <br />
            <small>
              <Icon icon="phone has-text-grey-light" />
              &nbsp;
              {driver.phone_number}
            </small>
          </>
        )}
        {!!driver.date_of_birth && (
          <>
            <br />
            <small>
              <Icon icon="birthday-cake has-text-grey-light" />
              &nbsp;
              {moment(driver.date_of_birth).format('DD/MM/YYYY')}
            </small>
          </>
        )}
        {this.props.showLicence && !!driver.driving_license_number && (
          <>
            <br />
            <small>
              <Icon icon="id-card has-text-grey-light" />
              &nbsp;
              {driver.driving_license_number}
            </small>
          </>
        )}
      </>
    );
  }
}

export default DriverList;
